import { render, staticRenderFns } from "./StatInspItemView.vue?vue&type=template&id=3f1d78fc"
import script from "./StatInspItemView.vue?vue&type=script&lang=js"
export * from "./StatInspItemView.vue?vue&type=script&lang=js"
import style0 from "./StatInspItemView.vue?vue&type=style&index=0&id=3f1d78fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports